<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="招工标题" prop="title">
                  <a-input v-model="queryParam.title" placeholder="请输入招工标题" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="计价方式" prop="pricingMethod">
                  <a-select v-model="queryParam.pricingMethod" placeholder="请选择计价方式">

                    <a-select-option value="0">议价</a-select-option>
                    <a-select-option value="1">按时计价</a-select-option>
                    <a-select-option value="2">按天计价</a-select-option>
                    <a-select-option value="3">按量计价</a-select-option>
                    <a-select-option value="4">一口价</a-select-option>
                    <a-select-option value="5">按时/天计价</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            <template v-if="advanced">
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 订单状态页签 -->
      <a-tabs type="border-card" v-model="statusTab" class="order-status-tabs" @change="onStatusTabChange">
        <a-tab-pane key="all">
          <span slot="tab"><a-icon type="appstore" /> {{ tabLabel('all') }}</span>
        </a-tab-pane>
        <a-tab-pane key="0">
          <span slot="tab"><a-icon type="clock-circle" /> {{ tabLabel('0') }}</span>
        </a-tab-pane>
        <a-tab-pane key="5">
          <span slot="tab"><a-icon type="hourglass" /> {{ tabLabel('5') }}</span>
        </a-tab-pane>
        <a-tab-pane key="1">
          <span slot="tab"><a-icon type="sync" /> {{ tabLabel('1') }}</span>
        </a-tab-pane>
        <a-tab-pane key="2">
          <span slot="tab"><a-icon type="check-circle" /> {{ tabLabel('2') }}</span>
        </a-tab-pane>
        <a-tab-pane key="3">
          <span slot="tab"><a-icon type="customer-service" /> {{ tabLabel('3') }}</span>
        </a-tab-pane>
        <a-tab-pane key="4">
          <span slot="tab"><a-icon type="close-circle" /> {{ tabLabel('4') }}</span>
        </a-tab-pane>
        <a-tab-pane key="-1">
          <span slot="tab"><a-icon type="question-circle" title="用户未实名、未支付诚意金的订单"/> {{ tabLabel('-1') }}</span>
        </a-tab-pane>
      </a-tabs>
      <!-- 工具栏 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.manualCreateForm.handleAdd()" v-hasPermi="['order:order:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-select
          v-model="queryParam.orderSource"
          allow-clear
          placeholder="订单来源"
          style="width: 140px; margin-left: 8px;"
          @change="handleQuery"
        >
          <a-select-option :value="0">雇主发布</a-select-option>
          <a-select-option :value="1">后台创建</a-select-option>
        </a-select>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <manual-create-form
        ref="manualCreateForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 2100 }"
        class="order-table"
      >
        <span slot="title" slot-scope="text, record">
          <a v-if="record && record.title" class="order-title-link" @click="openOrderDetail(record)">{{ record.title }}</a>
        </span>
        <span slot="type" slot-scope="text, record">
          <a-tag v-if="record.type === 0" color="blue">找个人</a-tag>
          <a-tag v-else-if="record.type === 1" color="green">找公司</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 0" color="blue">接单中</a-tag>
          <a-tag v-else-if="record.status === 1" color="cyan">服务中</a-tag>
          <a-tag v-else-if="record.status === 5" color="geekblue">待服务</a-tag>
          <a-tag v-else-if="record.status === 2" color="green">已完成</a-tag>
          <a-tag v-else-if="record.status === 3" color="orange">售后中</a-tag>
          <a-tag v-else-if="record.status === 4" color="red">已取消</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="orderSource" slot-scope="text, record">
          <a-tag v-if="record.orderSource === 1" color="purple">后台创建</a-tag>
          <a-tag v-else color="blue">雇主发布</a-tag>
        </span>
        <span slot="pricingMethod" slot-scope="text, record">
          <a-tag v-if="record.pricingMethod === 0" >议价</a-tag>
          <a-tag v-else-if="record.pricingMethod === 1" color="blue">按时计价</a-tag>
          <a-tag v-else-if="record.pricingMethod === 2" color="green">按天计价</a-tag>
          <a-tag v-else-if="record.pricingMethod === 3" color="purple">按量计价</a-tag>
          <a-tag v-else-if="record.pricingMethod === 4" color="orange">一口价</a-tag>
          <a-tag v-else-if="record.pricingMethod === 5" color="cyan">{{ record.unit === '天' ? '按天计价' : '按时计价' }}</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="money" slot-scope="text, record">
          {{ record.money != null ? '¥' + Number(record.money).toFixed(2) : '-' }}
        </span>
        <span slot="payAmount" slot-scope="text, record">
          {{ record.payAmount != null ? '¥' + Number(record.payAmount).toFixed(2) : '-' }}
        </span>
        <span slot="payType" slot-scope="text, record">
          <a-tag v-if="record.payType === 0" color="gold">金币支付</a-tag>
          <a-tag v-else-if="record.payType === 1" color="green">微信</a-tag>
          <a-tag v-else-if="record.payType === 2" color="blue">支付宝</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="workStartTime" slot-scope="text, record">
          {{ parseTime(record.workStartTime) }}
        </span>
        <span slot="workEndTime" slot-scope="text, record">
          {{ parseTime(record.workEndTime) }}
        </span>
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="number" slot-scope="text, record">
          {{ record.numberOfWorkers + record.man + record.woman }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['order:order:edit']">
            <a-icon type="edit" />详情
          </a>
          <template v-if="record.orderSource === 1">
            <a-divider type="vertical" v-hasPermi="['order:order:edit']" />
            <a @click="handleManualEdit(record)" v-hasPermi="['order:order:edit']">
              <a-icon type="edit" />编辑
            </a>
            <a-divider type="vertical" v-hasPermi="['order:order:edit']" />
            <a @click="handleManualStatus(record, 'close')" v-hasPermi="['order:order:edit']" v-if="record.status === 0">
              <a-icon type="stop" />关闭
            </a>
            <a @click="handleManualStatus(record, 'reopen')" v-hasPermi="['order:order:edit']" v-if="record.status === 4">
              <a-icon type="redo" />重开
            </a>
          </template>
          <a-divider type="vertical" v-hasPermi="['order:order:put']" v-if="record.orderSource !== 1 && record.status === 0" />
          <a
            v-hasPermi="['order:order:put']"
            v-if="record.orderSource !== 1 && record.status === 0"
            :disabled="putOrderSubmittingId === record.id"
            @click="handlePutOrder(record)"
          >
            <a-icon type="notification" />手动派单
          </a>
          <a-divider type="vertical" v-hasPermi="['order:order:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['order:order:remove']">
            <a-icon type="delete" />删除
          </a>
          <a-divider type="vertical" v-hasPermi="['order:order:edit']" v-if="record.status === 3" />
          <a @click="handleOrderAfter(record)" v-hasPermi="['order:order:edit']" v-if="record.status === 3">
            <a-icon type="edit" />查看售后
          </a>
          <a-divider type="vertical" v-hasPermi="['order:order:edit']" v-if="record.status === 2" />
          <a @click="handleInvoice(record)" v-hasPermi="['order:order:edit']" v-if="record.status === 2 && record.invoiceId && record.invoiceId != '0'" >
            <a-icon type="file-text" />开票
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

      <!-- 开票弹窗 -->
      <a-modal
        title="开票"
        :visible="invoiceModalVisible"
        :confirm-loading="invoiceSubmitting"
        width="800px"
        @ok="handleConfirmInvoice"
        @cancel="handleCancelInvoice"
      >
        <a-spin :spinning="invoiceInfoLoading">
          <!-- 发票信息展示 -->
          <div v-if="currentInvoiceInfo && Object.keys(currentInvoiceInfo).length > 0" class="invoice-info-section">
            <h3 style="margin-bottom: 16px;">发票信息</h3>
            <a-descriptions :column="2" bordered>
              <a-descriptions-item label="发票类型">{{ currentInvoiceInfo.invoiceType || '-' }}</a-descriptions-item>
              <a-descriptions-item label="发票内容">{{ currentInvoiceInfo.invoiceContent || '-' }}</a-descriptions-item>
              <a-descriptions-item label="抬头类型">
                <span v-if="currentInvoiceInfo.titleType === 0 || currentInvoiceInfo.titleType === '0'">个人</span>
                <span v-else-if="currentInvoiceInfo.titleType === 1 || currentInvoiceInfo.titleType === '1'">企业</span>
                <span v-else>-</span>
              </a-descriptions-item>
              <a-descriptions-item label="发票抬头">{{ currentInvoiceInfo.title || '-' }}</a-descriptions-item>
              <a-descriptions-item label="公司税号" :span="2">{{ currentInvoiceInfo.tax || '-' }}</a-descriptions-item>
              <a-descriptions-item label="联系邮箱">{{ currentInvoiceInfo.email || '-' }}</a-descriptions-item>
              <a-descriptions-item label="联系电话">{{ currentInvoiceInfo.mobile || '-' }}</a-descriptions-item>
            </a-descriptions>
          </div>
          <a-empty v-else description="暂无发票信息" style="margin: 20px 0;" />

          <!-- 上传发票 -->
          <div class="invoice-upload-section" style="margin-top: 24px;">
            <h3 style="margin-bottom: 16px;">上传发票 <span style="color: red;">*</span></h3>
            <file-upload
              type="image"
              :defaultList="invoicePictureArr"
              :count="1"
              @input="getInvoiceImage"
            ></file-upload>
            <div style="margin-top: 8px; color: #999; font-size: 12px;">
              支持jpg、png格式，大小不超过2MB
            </div>
          </div>
        </a-spin>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageOrder,
  delOrder,
  updateOrder,
  invoiceOrder,
  putOrder,
  manualAddOrder,
  manualEditOrder,
  manualChangeOrderStatus
} from '@/api/order/order'
import { getInvoice } from '@/api/invoice/invoice'
import CreateForm from './modules/CreateForm'
import ManualCreateForm from './modules/ManualCreateForm'
import { tableMixin } from '@/store/table-mixin'
import { guid } from '@/components/图片上传/utils/ruoyi'

export default {
  name: 'Order',
  components: {
    CreateForm,
    ManualCreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      statusTab: 'all',
      /** 各状态订单数量，key 为 all | 0|1|2|3|4，用于 tab 展示 */
      statusCounts: {
        all: null,
        0: null,
        1: null,
        5: null,
        2: null,
        3: null,
        4: null
      },
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 开票相关
      invoiceModalVisible: false, // 开票弹窗显示状态
      invoiceInfoLoading: false, // 发票信息加载状态
      invoiceSubmitting: false, // 开票提交状态
      currentOrder: null, // 当前操作的订单
      /** 手动派单请求中，记录订单 id，用于禁用按钮 */
      putOrderSubmittingId: null,
      currentInvoiceInfo: {}, // 当前发票信息
      invoicePictureArr: [], // 发票图片文件列表（用于file-upload组件）
      invoiceImageUrl: '', // 发票图片URL
      // 查询参数
      queryParam: {
        userId: null,
        userName: null,
        orderId: null,
        orderName: null,
        orderSource: undefined,
        type: null,
        status: null,
        title: null,
        picture: null,
        content: null,
        category: null,
        longitude: null,
        latitude: null,
        provinceCode: null,
        cityCode: null,
        areaCode: null,
        workLocation: null,
        address: null,
        pricingMethod: undefined,
        workStartTime: null,
        workEndTime: null,
        workTime: null,
        invoicing: null,
        invoiceId: null,
        invoicePicture: null,
        money: null,
        unit: null,
        perCapitaProduction: null,
        numberOfWorkers: null,
        woman: null,
        man: null,
        genderRequirements: null,
        ageRequirements: null,
        discountAmount: null,
        payAmount: null,
        payType: null,
        payTime: null,
        watchNum: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 80,
          align: 'center',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '招工标题',
          dataIndex: 'title',
          width: 180,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'title' }
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户名称',
          dataIndex: 'userName',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '个人/企业',
          dataIndex: 'type',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '订单状态',
          dataIndex: 'status',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '订单来源',
          dataIndex: 'orderSource',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'orderSource' }
        },
        {
          title: '师傅人数',
          dataIndex: 'numberOfWorkers',
          width: 100,
          scopedSlots: { customRender: 'number' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '内容描述',
          dataIndex: 'content',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '详细地址',
          dataIndex: 'address',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '计价方式',
          dataIndex: 'pricingMethod',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'pricingMethod' }
        },
        {
          title: '金额',
          dataIndex: 'money',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'money' }
        },
        
        {
          title: '支付金额',
          dataIndex: 'payAmount',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'payAmount' }
        },
        {
          title: '支付类型',
          dataIndex: 'payType',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'payType' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 240,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.applyStatusByTab()
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 根据状态页签设置查询参数 */
    applyStatusByTab () {
      if (this.statusTab === 'all') {
        this.queryParam.status = undefined
      } else {
        this.queryParam.status = parseInt(this.statusTab, 10)
      }
    },
    /** 状态页签切换 */
    onStatusTabChange () {
      this.queryParam.pageNum = 1
      this.applyStatusByTab()
      this.getList()
    },
    /** tab 文案（含数量），如：全部(12)、接单中(5) */
    tabLabel (key) {
      const labels = { all: '全部', 0: '接单中', 1: '服务中', 5: '待服务', 2: '已完成', 3: '售后中', 4: '已取消', '-1': '其他' }
      const n = this.statusCounts[key]
      return n != null ? `${labels[key]}(${n})` : labels[key]
    },
    /** 拉取各状态订单数量（与当前查询条件一致），用于 tab 展示 */
    fetchStatusCounts () {
      const base = { ...this.queryParam, pageNum: 1, pageSize: 1 }
      const keys = ['all', '0', '1', '5', '2', '3', '4', '-1']
      const promises = keys.map(k =>
        pageOrder({ ...base, status: k === 'all' ? undefined : parseInt(k, 10) })
      )
      Promise.all(promises).then(responses => {
        keys.forEach((k, i) => {
          const data = responses[i] && responses[i].data
          this.$set(this.statusCounts, k, data && data.total != null ? data.total : 0)
        })
      })
    },
    /** 查询招工订单信息列表 */
    getList () {
      this.applyStatusByTab()
      this.loading = true
      pageOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
        this.fetchStatusCounts()
      })
    },

    /** 点击招工标题打开订单详情 */
    openOrderDetail (record) {
      if (this.$refs.createForm && record) {
        this.$refs.createForm.handleUpdate(record, undefined)
      }
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.statusTab = 'all'
      this.queryParam = {
        userId: undefined,
        type: undefined,
        status: undefined,
        orderSource: undefined,
        userName: undefined,
        orderId: undefined,
        orderName: undefined,
        title: undefined,
        picture: undefined,
        content: undefined,
        category: undefined,
        longitude: undefined,
        latitude: undefined,
        provinceCode: undefined,
        cityCode: undefined,
        areaCode: undefined,
        workLocation: undefined,
        address: undefined,
        pricingMethod: undefined,
        workStartTime: undefined,
        workEndTime: undefined,
        workTime: undefined,
        invoicing: undefined,
        invoiceId: undefined,
        invoicePicture: undefined,
        money: undefined,
        unit: undefined,
        perCapitaProduction: undefined,
        numberOfWorkers: undefined,
        woman: undefined,
        man: undefined,
        genderRequirements: undefined,
        ageRequirements: undefined,
        discountAmount: undefined,
        payAmount: undefined,
        payType: undefined,
        payTime: undefined,
        watchNum: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 手动派单（后端向在线且符合条件的师傅推送 WebSocket） */
    handlePutOrder (row) {
      const that = this
      const title = row.title ? `「${row.title}」` : `订单 ID ${row.id}`
      this.$confirm({
        title: '确认手动派单？',
        content: `将对符合条件的接单中师傅重新推送 ${title}，是否继续？`,
        onOk () {
          that.putOrderSubmittingId = row.id
          return putOrder({ id: row.id })
            .then(() => {
              that.$message.success('派单已触发')
            })
            .finally(() => {
              that.putOrderSubmittingId = null
            })
        }
      })
    },
    /** 后台创建的订单 - 编辑 */
    handleManualEdit (row) {
      if (this.$refs.manualCreateForm && row) {
        this.$refs.manualCreateForm.handleUpdate(row)
      }
    },
    /** 后台创建的订单 - 关闭（接单中→已取消）/ 重开（已取消→接单中） */
    handleManualStatus (row, action) {
      const that = this
      const isClose = action === 'close'
      const title = row.title ? `「${row.title}」` : `订单 ID ${row.id}`
      this.$confirm({
        title: isClose ? '确认关闭该订单？' : '确认重开该订单？',
        content: isClose
          ? `关闭后 ${title} 将从师傅端招工大厅消失，是否继续？`
          : `重开后 ${title} 将重新出现在师傅端招工大厅（仍为只读展示，师傅不可抢单），是否继续？`,
        onOk () {
          return manualChangeOrderStatus({ id: row.id, action: action })
            .then(() => {
              that.$message.success(isClose ? '已关闭' : '已重开')
              that.getList()
            })
        }
      })
    },
    /**查看售后*/
    handleOrderAfter(row){
      this.$router.push({
        path: '/order/after',
        query: {
          orderId: row.id
        }
      })
    },

    /** 开票操作 - 打开弹窗 */
    handleInvoice(row) {
      this.currentOrder = row
      this.invoiceModalVisible = true
      this.invoicePictureArr = []
      this.invoiceImageUrl = ''
      this.currentInvoiceInfo = {}

      // 如果有已上传的发票图片，初始化文件列表
      if (row.invoicePicture) {
        this.invoicePictureArr = [{
          uid: guid(8, 10),
          name: row.invoicePicture,
          status: 'done',
          halfUrl: row.invoicePicture,
          url: row.invoicePicture,
          path: row.invoicePicture
        }]
        this.invoiceImageUrl = row.invoicePicture
      }

      // 如果有发票ID，获取发票信息
      if (row.invoiceId && row.invoiceId != '0') {
        this.getInvoiceInfo(row.invoiceId)
      }
    },

    /** 获取发票信息 */
    getInvoiceInfo(invoiceId) {
      this.invoiceInfoLoading = true
      getInvoice({ id: invoiceId }).then(response => {
        // 处理不同的响应格式：code可能是字符串"20001"或数字20001
        if (response.code === 20001 || response.code === '20001' || response.code === 1 || response.code === '1') {
          this.currentInvoiceInfo = response.data || {}
        } else {
          this.$message.warning(response.message || '获取发票信息失败')
        }
      }).catch(error => {
        console.error('获取发票信息失败：', error)
        this.$message.error('获取发票信息失败，请稍后重试')
      }).finally(() => {
        this.invoiceInfoLoading = false
      })
    },

    /** 获取上传的发票图片 */
    getInvoiceImage(info) {
      console.log('getInvoiceImage 接收到的数据:', info)

      // 兼容处理：如果传入的是字符串，转换为数组格式
      if (typeof info === 'string') {
        if (info) {
          this.invoiceImageUrl = info
          this.invoicePictureArr = [{
            uid: guid(8, 10),
            status: 'done',
            url: info,
            path: info,
            halfUrl: info
          }]
        } else {
          this.invoiceImageUrl = ''
          this.invoicePictureArr = []
        }
        return
      }

      // 数组格式处理
      if (!info || !Array.isArray(info) || info.length === 0) {
        this.invoiceImageUrl = ''
        this.invoicePictureArr = []
        return
      }

      // 单图上传（count=1），直接取第一张图片的 URL
      if (info.length === 1) {
        const firstFile = info[0]
        // 优先使用 url，其次使用 path，最后使用 halfUrl
        const imageUrl = firstFile.url || firstFile.path || firstFile.halfUrl
        if (imageUrl) {
          this.invoiceImageUrl = imageUrl
          this.invoicePictureArr = info
        } else {
          console.error('无法获取图片地址，文件对象:', firstFile)
          this.$message.error('获取图片地址失败，请重试')
        }
      } else {
        // 多图上传，用逗号连接所有图片 URL（虽然count=1，但保留兼容性）
        const urls = info.map(ele => {
          return ele.url || ele.path || ele.halfUrl
        }).filter(url => url) // 过滤掉空值
        if (urls.length > 0) {
          this.invoiceImageUrl = urls.join(',')
          this.invoicePictureArr = info
        } else {
          console.error('无法获取图片地址，文件列表:', info)
          this.$message.error('获取图片地址失败，请重试')
        }
      }
    },

    /** 确认开票 */
    handleConfirmInvoice() {
      if (!this.invoiceImageUrl) {
        this.$message.warning('请先上传发票图片')
        return
      }

      if (!this.currentOrder) {
        this.$message.error('订单信息不存在')
        return
      }

      this.invoiceSubmitting = true

      // 调用API更新订单
      invoiceOrder({
        id: this.currentOrder.id,
        platformInvoicingPicture: this.invoiceImageUrl // 发票图片
      }).then(() => {
        this.$message.success('开票成功', 3)
        this.invoiceModalVisible = false
        // 清除数据
        this.currentOrder = null
        this.currentInvoiceInfo = {}
        this.invoicePictureArr = []
        this.invoiceImageUrl = ''
        this.invoiceInfoLoading = false
        this.getList()
      }).catch(error => {
        console.error('开票失败：', error)
        this.$message.error('开票失败，请稍后重试')
      }).finally(() => {
        this.invoiceSubmitting = false
      })
    },

    /** 取消开票 */
    handleCancelInvoice() {
      this.invoiceModalVisible = false
      this.currentOrder = null
      this.currentInvoiceInfo = {}
      this.invoicePictureArr = []
      this.invoiceImageUrl = ''
      this.invoiceInfoLoading = false
      this.invoiceSubmitting = false
    },

    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('order/order/export', {
            ...that.queryParam
          }, `招工订单信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.order-status-tabs {
  margin-bottom: 0;
}
/* 仅用 tab 切换筛选，无面板内容，隐藏内容区避免与表格间大片空白 */
.order-status-tabs /deep/ .ant-tabs-content,
.order-status-tabs /deep/ .ant-tabs-content-holder,
.order-status-tabs /deep/ .ant-tabs-content-animated,
.order-status-tabs /deep/ .ant-tabs-tabpane {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}
.order-status-tabs /deep/ .ant-tabs-bar {
  margin-bottom: 0;
}

.order-table {
  /deep/ .ant-table-thead > tr > th {
    padding: 16px;
    font-weight: 500;
  }

  /deep/ .ant-table-tbody > tr > td {
    padding: 16px;
  }

  /deep/ .ant-table-tbody > tr:hover > td {
    background: #f5f5f5;
  }

  /deep/ .ant-table-tbody > tr > td .ant-divider {
    margin: 0 8px;
  }

  /deep/ .ant-table-tbody > tr > td a {
    margin: 0 4px;
  }
}

// ==================== 开票弹窗样式 ====================
.invoice-info-section {
  margin-bottom: 24px;
}

.invoice-upload-section {
  // file-upload 组件样式已内置，无需额外样式
}
</style>
